import React from 'react';

interface Post {
  title: string;
  date: string;
  content: React.ReactNode;
}

const posts: Post[] = [
  {
    title: 'Welcome to my blog',
    date: '6 March 2026',
    content: (
      <>
        <p>
          I'm Stuart Marshall — I study econ, I'm a Seattle native, and I'm a
          techie.
        </p>
        <p>
          You may find posts about econ and software and whatever I'm thinking
          about.
        </p>
      </>
    ),
  },
];

function Blog(): React.JSX.Element {
  return (
    <div>
      {posts.map((post, index) => (
        <div key={index}>
          <h4>{post.title}</h4>
          <small className="text-muted">{post.date}</small>
          <div className="mt-2">{post.content}</div>
          {index < posts.length - 1 && <hr />}
        </div>
      ))}
    </div>
  );
}

export default Blog;
